import React, { useState } from "react";
import { AddProgramContainer, TitleBar, ProgressContainer } from "./styles";
import ProgressBar from "../../../../../common/ProgressBar";
import Modal from "../../../../../common/Modal";
import { createSteps } from "./config";
import { validateIsValid } from "../../../../../common/utils";
import callAPI from "../../../../../api/apiCaller";
import { useNavigate } from "react-router-dom";
import { Context } from "../../../../../Store";
import { toastTrackedMessage } from "../../../../../Store/Toasts/actions";
import { getUserInfo } from "../../../../../Store/User/accessors";
import { checkIfTokenValid } from "../../../../../common/utils";
import { loginUser } from "../../../../../Store/User/actions";

function AddProgram({ closeModal, isAddCreate, isMain }) {
  const [currentStep, setCurrentStep] = React.useState(0);
  const [isSavingProgram, setIsSavingProgram] = React.useState(false);
  const { state, dispatch } = React.useContext(Context);
  const [newProgramId, setNewProgramId] = React.useState(false);
  const [programImage, setProgramImage] = useState();
  const [newProgramManagerEmail, setNewProgramManagerEmail] =
    React.useState("");
  const [programNameExists, setProgramNameExists] = useState(false);
  const navigate = useNavigate();
  const userdata = getUserInfo(state);
  const [programForm, setProgramForm] = React.useState({
    title: "",
    description: "",
    organization: "",
    image: "",
    subscriptionId: "",
    programType: "1_1_NETWORK",
    programManagers: [],
    applicationForm: {
      accepts: {
        mentor: false,
        mentee: false,
        member: false,
      },
      mentor: [],
      mentee: [],
      member: [],
    },
  });

  const Image = (imageKey) => {
    callAPI(dispatch, "getSignedUrl", {
      key: imageKey,
    }).then((res) => {
      setProgramImage(res?.data?.link);
    });
  };
  const [stepIsValid, setStepIsValid] = React.useState({});
  let currentStepConfig = createSteps[currentStep];
  // React.useEffect(() => {
  //   setStepIsValid(createInitialValid(currentStepConfig.isValidFields));
  // }, [currentStep]);

  async function saveProgram() {
    setIsSavingProgram(true);

    return callAPI(dispatch, "addNewProgram", {
      ...programForm,
      subscriptionId: userdata?.subscription?.id,
    });
  }
  return (
    <Modal
      isAddCreate={isAddCreate}
      isMain={isMain}
      setModalrespon={true}
      title={
        <TitleBar>
          {currentStep === createSteps.length - 1
            ? "Program Created"
            : "Add New Program"}
          {/* <ProgressContainer>
            <ProgressBar
              percent={currentStep / (createSteps.length - 1)}
              type={currentStep === createSteps.length - 1 ? "done" : "normal"}
            />
          </ProgressContainer> */}
        </TitleBar>
      }
      onClose={closeModal}
      onOutsideClick={() => {}}
      actions={[
        {
          text: "Cancel",
          variant: "secondary",
          // icon: "cross",
          isMarginRight: true,
          isNotRound: true,
          disabled: currentStep === createSteps.length - 1,
          onClick: () => closeModal(false),
        },
        {
          text: "Back",
          icon: "back",
          variant: "secondary",
          isNotRound: true,
          disabled: currentStep === 0 || currentStep === createSteps.length - 1,
          onClick: () => {
            setCurrentStep(currentStep - 1);
          },
        },

        {
          text: currentStep === createSteps.length - 1 ? "Done" : "Next",
          icon: isSavingProgram
            ? "loading"
            : currentStep === createSteps.length - 1
            ? "tick"
            : "next",
          variant: "primary",
          isNotRound: true,
          iconLast: true,
          disabled: !validateIsValid(stepIsValid),
          onClick: () => {
            if (currentStep === createSteps.length - 1) {
              closeModal(true);
              navigate(`/programs/${newProgramId}/home`);
            } else if (currentStep === createSteps.length - 2) {
              saveProgram().then((response) => {
                /**  call another APi **/
                checkIfTokenValid(dispatch)
                  .then((res) => {
                    dispatch(loginUser(res));
                  })
                  .catch((err) => {});
                /**  call another APi **/

                setIsSavingProgram(false);

                if (!response?.isResponseOk) {
                  closeModal(true);
                  toastTrackedMessage(1, response?.message, "failure");
                  return response?.message;
                }
                setNewProgramId(response?.data?.programId);
                setIsSavingProgram(false);
                setCurrentStep(currentStep + 1);
              });
            }

            // if(programForm.programType==='TEAM'){

            //   if(currentStep===1){
            //     setCurrentStep(currentStep + 2);
            //     saveProgram().then((response)=>{
            //       setIsSavingProgram(false);

            //       if(!response.isResponseOk){
            //         closeModal(true);
            //         toastTrackedMessage(1, response.message, "failure")
            //         return response.message

            //       }
            //       setNewProgramId(response.data.programId)
            //       setIsSavingProgram(false);

            //     })
            //     return
            //   }
            //   setCurrentStep(currentStep + 1);

            // }
            else {
              setCurrentStep(currentStep + 1);
            }
          },
        },
      ]}
    >
      {" "}
      <>
        <ProgressContainer>
          <ProgressBar currentStep={currentStep} />
        </ProgressContainer>

        <AddProgramContainer>
          <currentStepConfig.component
            isValid={stepIsValid}
            setIsValid={setStepIsValid}
            programForm={programForm}
            setProgramForm={setProgramForm}
            newProgramId={newProgramId}
            Image={Image}
            programImage={programImage}
            setNewProgramManagerEmail={setNewProgramManagerEmail}
            newProgramManagerEmail={newProgramManagerEmail}
            setProgramNameExists={setProgramNameExists}
            programNameExists={programNameExists}
          />
        </AddProgramContainer>
      </>
    </Modal>
  );
}
export default AddProgram;
